import type { ComponentType } from 'react'
import type { IApiClient } from '@tn/ui'
import { GccApp } from '@tn/ui/gcc'
import { FinApp } from '@tn/ui/fin'
import { HttpApiClient } from './HttpApiClient'
import { FinHttpApiClient } from './fin/finApi'

export interface VariantEntry {
  App: ComponentType
  api: () => IApiClient
}

/**
 * Path prefix → variant root component and API client factory.
 * main.tsx resolves window.location.pathname against these and falls back to
 * the base App, so /finance serves the Finance variant while / stays the
 * unmodified product.
 */
export const variantApps: Record<string, VariantEntry> = {
  '/gcc': { App: GccApp, api: () => new HttpApiClient('/api') },
  '/finance': { App: FinApp, api: () => new FinHttpApiClient() },
}
